import { createSlice } from "@reduxjs/toolkit";

const intialStepState: boolean = false;

export const darkLightSlice = createSlice({
  name: "darkLight",
  initialState: intialStepState,
  reducers: {
    changeDarkLight: (state) => {
      return state = !state;
    },
  },
});

// Action creators are generated for each case reducer function
export const { changeDarkLight } = darkLightSlice.actions;

export default darkLightSlice.reducer;
